<div>
  <button mat-raised-button color="primary" (click)="send()" [disabled]="isButtonDisabled">
    <mat-icon>forward_to_inbox</mat-icon> {{ buttonLabel }}
  </button>
</div>
